import React, { useEffect } from "react";
import Logo2 from '../Images/Milaaz2.png'
import BackB from "../Components/BackB";
import { FaSignOutAlt } from "react-icons/fa";
import { auth } from "../Components/Firebase";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

function AdminHead () {
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user) {
                navigate("/"); 
            }
        });

        return () => unsubscribe();
    }, [navigate]);

    const Signout = () => {
        auth.signOut()
            .then(() => navigate('/'))
            .catch((error) => console.error("Error signing out: ", error));
    };

    return (
        <React.Fragment>
            <header className="Header">
                <BackB />
                <button className="LogoutButton" onClick={Signout} style={{background: 'none', cursor: 'pointer', border: 'none'}}>
                    <FaSignOutAlt size={25} color="#fff"/>
                </button>
                <img src={Logo2} alt="Logo2" />
                <h1>מערכת ניהול</h1>
            </header>
        </React.Fragment>
    );
}

export default AdminHead;
